import React from "react"

import { styled } from "@mui/styles"

export const Block = styled("div")({
  "&:last-child": { paddingBottom: 0 },

  display: "flex",
  flexDirection: "column",
  paddingBottom: 10,
  paddingRight: 40,
  width: "100%",
});

export const Container = styled("section")({
  display: "flex",
  flexDirection: "column",
  width: 600,
});

export const Header = ({ children, className, content, style }) => (
  <div
    style={{
      color: "#554854",
      fontWeight: "bold",
      textTransform: "uppercase",
      ...style,
    }}
    className={className}
  >
    {content || children}
  </div>
);

export const Name = ({ children, className, content, style }) => (
  <div
    style={{
      fontWeight: "bold",
      marginBottom: 2,
      whiteSpace: "nowrap",
      ...style,
    }}
    className={className}
  >
    {content || children}
  </div>
);

export const Tip = ({ children, className, content, style, ...props }) => (
  <div
    {...props}
    style={{
      color: "#757575",
      fontSize: 12,
      ...style,
    }}
    className={className}
  >
    {content || children}
  </div>
);

export const TipHTML = ({ className, style, htmlText }) => (
  <div
    style={{
      color: "#757575",
      fontSize: 12,
      lineHeight: "16px",
      ...style,
    }}
    dangerouslySetInnerHTML={{ __html: htmlText }}
    className={className}
  ></div>
);
export const Error = styled(Tip)({
  color: "#cf4444 !important",
});

